var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovimReceber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "movim-receber",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_691",
    "data-name": "Elipse 691",
    cx: 10,
    cy: 10,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder-download",
    d: "M61.418,77.8h-.973V74.584a.878.878,0,0,0-1.755,0V77.8h-.973a.585.585,0,0,0-.414,1l1.85,1.85a.584.584,0,0,0,.827,0l1.85-1.85a.585.585,0,0,0-.414-1Z",
    transform: "translate(-49.499 -67.359)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovimReceber);
export default __webpack_public_path__ + "static/media/movim-receber.67d7b2af375637711ebbb4a708c1aebe.svg";
export { ForwardRef as ReactComponent };